module.exports = "https://www.gc-pro.gnp.com.mx/cff309b6ce083151da98da076e9961cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/registro/2.png
// module id = 1051
// module chunks = 0 1